<div class="content-container">
  <div class="content-card" style="display: flex; flex-direction: column">
    <img src="/images/logo.svg" class="logo" />
    <router-outlet></router-outlet>
  </div>
</div>
